import {
  Button,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  Text,
} from '@ritualco/jutsu'
import { HeraModal } from 'components/HeraModal'

interface IncentiveLeaveDraftModalProps {
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
}
// todo: add contentful strings
export const NoPaymentMethodModal = ({
  isOpen,
  onCancel,
  onConfirm,
}: IncentiveLeaveDraftModalProps) => {
  return (
    <HeraModal
      scrollBehavior={'outside'}
      size="xl"
      isOpen={isOpen}
      onClose={onCancel}
    >
      <ModalHeader>
        Unable to Launch
        <Text
          color="grayscale.secondary"
          pt={1}
          fontSize="small"
          fontWeight="normal"
        >
          No payment method
        </Text>
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Text color="grayscale.secondary">
          Please set up a payment method in order to launch this incentive.
          Don’t worry, this incentive will be saved as a draft for you to launch
          as soon as possible.
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button
          colorScheme="transparent"
          mr={2}
          onClick={onCancel}
          color="grayscale.secondary"
        >
          Cancel
        </Button>
        <Button type="submit" onClick={onConfirm}>
          Go to Billing
        </Button>
      </ModalFooter>
    </HeraModal>
  )
}
